/**
 * Dynamic Checkout Cart Scroll Handler
 * Expands the checkout container when scrolling, collapses when scrolled to top
 * Uses MutationObserver to handle dynamically loaded content
 */
(function() {
  function initScrollHandler(element) {
    if (element.dataset.scrollHandlerInit) return;
    element.dataset.scrollHandlerInit = 'true';
    
    // Add smooth transition CSS
    element.style.transition = 'max-height 0.3s ease-out';
    
    element.addEventListener('scroll', function() {
      if (this.scrollTop > 0) {
        this.style.maxHeight = '100px';
      } else {
        this.style.maxHeight = '34px';
      }
    });
  }

  function checkAndInit() {
    const dynamicCheckout = document.getElementById('dynamic-checkout-cart');
    if (dynamicCheckout) {
      initScrollHandler(dynamicCheckout);
    }
  }

  function init() {
    checkAndInit();

    const observer = new MutationObserver(function(mutations) {
      checkAndInit();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', checkAndInit);
    document.addEventListener('cart:updated', checkAndInit);
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Cart Footer Padding Adjustment
 * Dynamically adjusts main content padding for fixed footer (mobile only)
 */
(function() {
  let adjustmentTimeout;
  
  function isMobile() {
    return window.innerWidth < 768;
  }
  
  function adjustMainContentPadding() {
    const footer = document.getElementById('main-cart-footer');
    const mainContent = document.getElementById('MainContent');
    
    if (footer && mainContent) {
      if (isMobile()) {
        // Get the actual footer height
        const footerHeight = footer.getBoundingClientRect().height + 30;
        // Add extra spacing for safety (20px buffer)
        const paddingValue = Math.ceil(footerHeight);
        mainContent.style.paddingBottom = paddingValue + 'px';
      } else {
        mainContent.style.paddingBottom = '';
      }
    }
  }
  
  // Check if user has scrolled to bottom of page
  function checkScrollPosition() {
    if (!isMobile()) return; // Only check on mobile
    
    const footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    
    // Calculate if we're at the bottom (with 10px threshold)
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const atBottom = scrollTop + clientHeight >= scrollHeight - 10;
    
    // Toggle class based on scroll position
    if (atBottom) {
      footer.classList.add('at-bottom');
    } else {
      footer.classList.remove('at-bottom');
    }
  }
  
  // Use ResizeObserver to detect footer height changes
  if ('ResizeObserver' in window) {
    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      const resizeObserver = new ResizeObserver(function(entries) {        
        // Debounce the adjustment to avoid excessive calls
        clearTimeout(adjustmentTimeout);
        adjustmentTimeout = setTimeout(function() {
          adjustMainContentPadding();
        }, 150);
      });
      resizeObserver.observe(footer);
    }
  }
  
  // Use MutationObserver to detect footer content changes (with debounce)
  if ('MutationObserver' in window) {
    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      const mutationObserver = new MutationObserver(function(mutations) {
        
        // Debounce the adjustment to avoid excessive calls
        clearTimeout(adjustmentTimeout);
        adjustmentTimeout = setTimeout(function() {
          adjustMainContentPadding();
        }, 150);
      });
      mutationObserver.observe(footer, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }
  }
  
  // Wait for styles to load before measuring
  function waitForStylesToLoad() {
    const footer = document.getElementById('main-cart-footer');
    if (!footer) {
      return;
    }
    
    // Check if computed styles are applied
    const checkStyles = setInterval(function() {
      const computedStyle = window.getComputedStyle(footer);
      const hasStyles = computedStyle.paddingTop !== '0px' || computedStyle.paddingBottom !== '0px';
      
      if (hasStyles) {
        clearInterval(checkStyles);
        adjustMainContentPadding();
        checkScrollPosition();
      }
    }, 50);
    
    // Fallback timeout after 2 seconds
    setTimeout(function() {
      clearInterval(checkStyles);
      adjustMainContentPadding();
      checkScrollPosition();
    }, 2000);
  }
  
  // Initial adjustment with delay for DOM and styles
  setTimeout(waitForStylesToLoad, 100);
  
  // Fallback for window resize
  window.addEventListener('resize', function() {
    adjustMainContentPadding();
    checkScrollPosition();
  });
  
  // Check scroll position on scroll (mobile only)
  window.addEventListener('scroll', checkScrollPosition);
  
  // Adjust when cart updates
  document.addEventListener('cart:updated', function() {
    adjustMainContentPadding();
    setTimeout(checkScrollPosition, 100);
  });
  
  // Listen for Shopify cart update events
  document.addEventListener('shopify:section:load', function() {
    setTimeout(adjustMainContentPadding, 200);
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    setTimeout(adjustMainContentPadding, 200);
  });
})();
